import { FC } from "react";

import PicaxeLogo from "../../assets/PickaxeLogo";
import ConnectionButton from "../ConnectionButton/ConnectionButton";

import './Header.scss';


const Header: FC = () => {

	/* const connect = async () => {
		if (!connector){
			throw new Error();
		}
		// const provider = await (connector?.getProvider() || connector?.options?.getProvider());
		const provider = await (connector?.options?.getProvider? connector?.options?.getProvider() : connector?.getProvider());	// works too

		if (!provider){
			throw new Error();
		}
		const bscConnect = await import('../../utils/Binance/connect');
		bscConnect.connect(provider);
	} */


	return (
		<div className="Header">
			<PicaxeLogo/>
			<ConnectionButton/>
		</div>
	)
}

export default Header;